import { ReachAPI } from '../../ReachApi';
import { Log } from '../../AuxillaryService/Log';
import { LogLevel } from '../../Logging/LogLevel';
import { ILogMechanism } from '../../Logging/ILogMechanism';

export type LogItem = {
    level: LogLevel;
    message: string;
    code?: string;
    source: string;
    data: unknown;
};

/**
 * Log receiver which logs to C# player software.
 * @deprecated Replaced by {@link REACHPlayerLogForwarderMechanism}.
 */
export class LogToREACHPlayer implements ILogMechanism {
    private _logCodes: Record<string, number> = {};
    private _entryCache: LogItem[] = [];
    private _initialized = false;

    constructor() {
        this.getLogCodes();
    }

    private static translateLevelCode(level: string): string {
        switch (level.toLowerCase()) {
            case 'debug':
                return 'debug';
            case 'warning':
                return 'warning';
            case 'error':
                return 'error';
            case 'critical':
                return 'critical';
            default:
                return 'notice';
        }
    }

    private translateLogCode(code: string): number {
        if (typeof this._logCodes[code] !== 'undefined' || !REACH.Application) {
            return this._logCodes[code];
        }

        return REACH.Application.GetLoggingCode(code);
    }

    private getLogCodes = () => {
        ReachAPI.player
            .getReportCodes()
            .done((result: { codes: Record<string, number> }) => {
                if (result.codes) {
                    this._logCodes = result.codes;
                    this._initialized = true;

                    this._entryCache.forEach((entry) => {
                        this.LogMessage(
                            entry.level,
                            entry.message,
                            entry.code,
                            entry.source,
                            entry.data
                        );
                    });
                    this._entryCache = [];
                } else {
                    setTimeout(this.getLogCodes, 5000);
                }
            })
            .fail(() => {
                setTimeout(this.getLogCodes, 5000);
            });
    };

    public NamedEvent = (code: string, message: string, source: string, data: unknown): void => {
        //for legacy reach player logger, handle as regular log message at
        //notice level
        this.LogMessage(LogLevel.INFO, message, code, source, data);
    };

    public LogMessage = (
        level: LogLevel,
        message: string,
        code: string | undefined | null,
        source: string,
        data: unknown
    ): void => {
        // sanitize data
        if (data) {
            data = JSON.parse(JSON.stringify(data));
        }

        if (!this._initialized) {
            this._entryCache.push({
                level: level,
                message: message,
                code: code || undefined,
                source: source,
                data: data,
            });
        } else {
            // Only log known error codes to the player (which will be sent to
            // the server)
            if (code && typeof this._logCodes[code] !== 'undefined') {
                try {
                    REACH.Application?.Log(
                        LogToREACHPlayer.translateLevelCode(level),
                        code
                            ? this.translateLogCode(code)
                            : REACH.Application.GetLoggingCode('SIGNAGE_LEGACY_EVENT'),
                        message,
                        source || 'DigitalSignage',
                        data
                    );
                } catch (e) {
                    Log.Error('Failed to log message to player software', null, __fileline, {
                        error: {
                            string: String(e),
                            object: e,
                        },
                        message: {
                            level: level,
                            message: message,
                            code: code,
                            source: source,
                            data: data,
                        },
                    });
                }
            }
        }
    };
}
